<!-- Administration -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <mdb-icon fas icon="user-plus" class="fa-fw"></mdb-icon>
    <span class="h6" jhiTranslate="sidebar.admin.title">Administration</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TOOLS.path" data-id-cypress="sidebar-admin-tools" routerLinkActive="active-link" jhiTranslate="sidebar.admin.tools" mdbWavesEffect> Tools </a>
      </li>
      <li>
        <a
          data-id-cypress="sidebar-client"
          [routerLink]="PATHS.ADMIN_USER_MANAGEMENT.path"
          routerLinkActive="active-link"
          jhiTranslate="sidebar.admin.userManagement"
          mdbWavesEffect
        >
          User management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_MODERATOR_MANAGEMENT.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.moderatorManagement" mdbWavesEffect>
          Moderator management
        </a>
      </li>
      <li>
        <a
          [routerLink]="PATHS.ADMIN_IMPERSONATE_MANAGEMENT.path"
          routerLinkActive="active-link"
          data-id-cypress="sidebar-impersonate"
          jhiTranslate="sidebar.admin.impersonateManagement"
          mdbWavesEffect
        >
          Impersonate management
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_METRICS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.metrics" mdbWavesEffect> Metrics </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_HEALTH.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.health" mdbWavesEffect> Health </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_CONFIGURATION.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.configuration" mdbWavesEffect> Configuration </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_AUDITS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.audits" mdbWavesEffect> Audits </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_LOGS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.logs" mdbWavesEffect> Logs </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_COMPONENTS_LIST.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.components" mdbWavesEffect> Components </a>
      </li>
      <li *ngIf="swaggerEnabled">
        <a [routerLink]="PATHS.ADMIN_DOCS.path" routerLinkActive="active-link" jhiTranslate="sidebar.admin.api" mdbWavesEffect> API </a>
      </li>
      <li *ngIf="!inProduction">
        <a href="./h2-console" target="_tab" routerLinkActive="active-link" jhiTranslate="sidebar.admin.database" mdbWavesEffect> Database </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- Transporteurs -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <mdb-icon fas icon="truck" class="fa-fw"></mdb-icon>
    <span class="h6" jhiTranslate="sidebar.transporter.title">Transporters</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body [customClass]="'overflow-auto'">
    <ul>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_DASHBOARD.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.dashboard" mdbWavesEffect>
          Dashboard
        </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_NEW_SHOP.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.createNewShop" mdbWavesEffect> Create a Transporter </a>
      </li>
      <li>
        <a [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_IMPORT.path" routerLinkActive="active-link" jhiTranslate="sidebar.transporter.importTransporter" mdbWavesEffect>
          Import a Transporter
        </a>
      </li>
      <li *ngFor="let transporterOption of transporters; trackBy: trackById">
        <a routerLinkActive="active-link" [routerLink]="PATHS.ADMIN_TRANSPORTER_MANAGEMENT_ID_EDIT.path.replace(':id', transporterOption!.id!.toString())" mdbWavesEffect>
          {{ transporterOption.technicalName }}
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- Modérateurs -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <mdb-icon fas icon="user" class="fa-fw"></mdb-icon>
    <span class="h6" jhiTranslate="sidebar.moderator.title">Moderators</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <mdb-accordion [multiple]="false" aria-multiselectable="false">
      <jhi-bary-sidebar-accordion-moderator (goToEvent)="handleGoTo($event)"></jhi-bary-sidebar-accordion-moderator>
    </mdb-accordion>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<!-- ENTITIES -->
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <mdb-icon fas icon="th-list" class="fa-fw"></mdb-icon>
    <span class="h6" jhiTranslate="sidebar.entities.title">Entities</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <ul class="scrollable thin transparent">
      <li>
        <a class="dropdown-item" routerLink="acceptance" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.acceptance">Acceptance</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="available-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.availableItem">Available Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="basket" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.basket">Basket</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="basket-order" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.basketOrder">Basket Order</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transporterMember" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transporterMember">Commercial</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="customer" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.customer">Customer</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="cut-off" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.cutOff">Cut Off</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="delivery-step" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.deliveryStep">Delivery Step</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="directional-code" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.directionalCode">Directional Code</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="edi-history" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.ediHistory">Edi History</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="gazole-tax-value" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.gazoleTaxValue">Gazole Tax Value</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="import-history" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.importHistory">Import History</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="insurance-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.insuranceItem">Insurance Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="offer" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.offer">Offer</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="offer-description-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.offerDescriptionItem">Offer Description Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="payment-file-queue" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.paymentFileQueue">Payment File Queue</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="payment-transaction" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.paymentTransaction">Payment Transaction</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="pricing" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.pricing">Pricing</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="pricing-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.pricingItem">Pricing Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="pricing-option" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.pricingOption">Pricing Option</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="quotation-history" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.quotationHistory">Quotation History</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="registered-address" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.registeredAddress">Registered Address</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="special-place" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.specialPlace">Special Place</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="special-place-list" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.specialPlaceList">Special Place List</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="special-place-pricing" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.specialPlacePricing">Special Place Pricing</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="special-place-pricing-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.specialPlacePricingItem">Special Place Pricing Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="task" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.task">Task</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="tax" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.tax">Tax</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="translation" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.translation">Translation</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transport">Transport</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transporter" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transporter">Transporter</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transporter-configuration" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transporterConfiguration">Transporter Configuration</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport-incident" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transportIncident">Transport Incident</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport-incident-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transportIncidentItem">Transport Incident Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transportItem">Transport Item</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport-order" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transportOrder">Transport Order</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="transport-order-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()">
          <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
          <span jhiTranslate="global.menu.entities.transportOrderItem">Transport Order Item</span>
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>
